var css = {"linkBase":"LinkBase-module_linkBase__VUi39"};

export { css as default };
